import * as FaProLight from '@fortawesome/pro-light-svg-icons';
import * as FaProRegular from '@fortawesome/pro-regular-svg-icons';
import * as FaProSolid from '@fortawesome/pro-solid-svg-icons';

export const faIcons = {
  'front-desk': defineFaIcon('faConciergeBell'),
  lunch: defineFaIcon('faSoup'),
  wifi: defineFaIcon('faWifi'),
  'bike-tour': defineFaIcon('faBicycle'),
  'special-diet': defineFaIcon('faSalad'),
  facilities: defineFaIcon('faUniversalAccess'),
  'baggage-storage': defineFaIcon('faSuitcase'),
  sterilizing: defineFaIcon('faSprayCan'),
  honeymoon: defineFaIcon('faRingsWedding'),
  taxi: defineFaIcon('faTaxi'),
  mask: defineFaIcon('faHeadSideMask'),
  gym: defineFaIcon('faDumbbell'),
  generic: defineFaIcon('faCircle'),
  university: defineFaIcon('faUniversity'),
  basket: defineFaIcon('faShoppingBasket'),

  add: defineFaIcon('faAdd'),
  'arrow-down': defineFaIcon('faArrowDown'),
  'arrow-left': defineFaIcon('faArrowLeft'),
  'arrow-right': defineFaIcon('faArrowRight'),
  'arrow-up': defineFaIcon('faArrowUp'),
  'angle-down': defineFaIcon('faAngleDown'),
  'angle-left': defineFaIcon('faAngleLeft'),
  'angle-right': defineFaIcon('faAngleRight'),
  'angle-up': defineFaIcon('faAngleUp'),
  arrows: defineFaIcon('faArrows'),
  bed: defineFaIcon('faBed'),
  calendar: defineFaIcon('faCalendar'),
  'calendar-check': defineFaIcon('faCalendarCheck'),
  check: defineFaIcon('faCheck'),
  'child-reaching': defineFaIcon('faChildReaching'),
  close: defineFaIcon('faClose'),
  comment: defineFaIcon('faComment'),
  'contact-book': defineFaIcon('faContactBook'),
  'credit-card': defineFaIcon('faCreditCard'),
  eye: defineFaIcon('faEye'),
  'eye-splash': defineFaIcon('faEyeSlash'),
  'exclamation-triangle': defineFaIcon('faExclamationTriangle'),
  globe: defineFaIcon('faGlobe'),
  images: defineFaIcon('faImages'),
  'info-circle': defineFaIcon('faInfoCircle'),
  lock: defineFaIcon('faLock'),
  'map-marker-alt': defineFaIcon('faMapMarkerAlt'),
  minus: defineFaIcon('faMinus'),
  moon: defineFaIcon('faMoon'),
  star: defineFaIcon('faStar'),
  tag: defineFaIcon('faTag'),
  'trash-can': defineFaIcon('faTrashCan'),
  user: defineFaIcon('faUser'),
  magnify: defineFaIcon('faMagnifyingGlass'),
  pencil: defineFaIcon('faPencil'),
  'warn-circle': defineFaIcon('faCircleExclamation'),
  'shield-check': defineFaIcon('faShieldCheck'),

  'accessible-parking': defineFaIcon('faUniversalAccess'),
  'access-to-healthcare-professionals': defineFaIcon('faUserDoctor'),
  'air-conditioning': defineFaIcon('faAirConditioner'),
  'airport-shuttle': defineFaIcon('faVanShuttle'),
  'all-inclusive-meals': defineFaIcon('faUtensils'),
  'all-rooms-disinfected-daily': defineFaIcon('faSprayCan'),
  archery: defineFaIcon('faBowArrow'),
  'atm-on-site': defineFaIcon('faMoneyFromBracket'),
  'audio-visual-equipment-rental': defineFaIcon('faComputerSpeaker'),
  'auditory-guidance': defineFaIcon('faEarListen'),
  badminton: defineFaIcon('faBadminton'),
  'banquet-rooms': defineFaIcon('faChampagneGlasses'),
  bar: defineFaIcon('faMartiniGlass'),
  'bar-crawls': defineFaIcon('faChampagneGlasses'),
  bathhouse: defineFaIcon('faWaterLadder'),
  'bathroom-emergency-pull-cord': defineFaIcon('faUniversalAccess'),
  'bbq-facilities': defineFaIcon('faFireBurner'),
  beach: defineFaIcon('faUmbrellaBeach'),
  'beach-chairs-loungers': defineFaIcon('faPersonSeatReclined'),
  beachfront: defineFaIcon('faUmbrellaBeach'),
  'beauty-services': defineFaIcon('faLips'),
  'bicycle-rental': defineFaIcon('faBicycle'),
  'bike-tours': defineFaIcon('faBicycle'),
  'board-games-puzzles': defineFaIcon('faDice'),
  boating: defineFaIcon('faSailboat'),
  'body-thermometer': defineFaIcon('faThermometer'),
  'books-dvds-music-for-kids': defineFaIcon('faBook'),
  'bottled-water': defineFaIcon('faBottleWater'),
  bowling: defineFaIcon('faBowlingBallPin'),
  'breakfast-buffet': defineFaIcon('faPancakes'),
  'breakfast-in-the-room': defineFaIcon('faPancakes'),
  'breakfast-takeaway-containers': defineFaIcon('faBox'),
  'business-center': defineFaIcon('faBriefcase'),
  'buzzer-wireless-intercom': defineFaIcon('faPhoneIntercom'),
  'carbon-monoxide-sources': defineFaIcon('faHeat'),
  'car-for-hire': defineFaIcon('faCar'),
  'car-rental': defineFaIcon('faCar'),
  'cashless-payment-accepted': defineFaIcon('faCreditCard'),
  casino: defineFaIcon('faCards'),
  'cctv-in-common-areas': defineFaIcon('faCameraCctv'),
  'cctv-outside-property': defineFaIcon('faCameraCctv'),
  chapel: defineFaIcon('faChurch'),
  'chocolate-cookies': defineFaIcon('faCookie'),
  'cleaning-chemicals-used-are-effective-agaist-covid':
    defineFaIcon('faVirusCovidSlash'),
  'coffee-shop': defineFaIcon('faCoffeePot'),
  'common-areas-disinfected-daily': defineFaIcon('faSprayCan'),
  concierge: defineFaIcon('faConciergeBell'),
  'contactless-check-in-check-out': defineFaIcon('faSignalStream'),
  'breakfast-continental': defineFaIcon('faCroissant'),
  'cooking-class': defineFaIcon('faHatChef'),
  'couples-only': defineFaIcon('faPeoplePants'),
  cycling: defineFaIcon('faBicycle'),
  'daily-housekeeping': defineFaIcon('faHandSparkles'),
  darts: defineFaIcon('faBullseyeArrow'),
  'delivered-food-covered-securely': defineFaIcon('faShieldVirus'),
  'designated-smoking-area': defineFaIcon('faSmoking'),
  diving: defineFaIcon('faMaskSnorkel'),
  'electric-vehicle-charging-station': defineFaIcon('faBolt'),
  elevator: defineFaIcon('faElevator'),
  'face-masks-available-for-guests': defineFaIcon('faMaskFace'),
  'face-masks-on-staff': defineFaIcon('faHeadSideMask'),
  'facilities-for-disabled-guests': defineFaIcon('faUniversalAccess'),
  'family-rooms': defineFaIcon('faFamily'),
  'fax-services': defineFaIcon('faFax'),
  'fire-extinguishers': defineFaIcon('faFireExtinguisher'),
  fireplace: defineFaIcon('faFireplace'),
  'first-aid-kits': defineFaIcon('faKitMedical'),
  fishing: defineFaIcon('faFishingRod'),
  'fitness-center': defineFaIcon('faDumbbell'),
  'food-delivery': defineFaIcon('faPersonCarryBox'),
  'foot-bath': defineFaIcon('faBath'),
  'foreign-currency-exchange': defineFaIcon('faCircleDollar'),
  fruit: defineFaIcon('faAppleWhole'),
  'game-room': defineFaIcon('faTeddyBear'),
  garden: defineFaIcon('faFlowerTulip'),
  'gift-shop': defineFaIcon('faGift'),
  'golf-course-on-site': defineFaIcon('faGolfFlagHole'),
  'golf-course-within-3-5-km-2-mi': defineFaIcon('faGolfFlagHole'),
  'grocery-deliveries': defineFaIcon('faBasketShopping'),
  'guest-accommodations-disinfected-between-stays': defineFaIcon('faSprayCan'),
  'guest-accommodations-sealed-after-cleaning': defineFaIcon('faSeal'),
  'guest-health-checks': defineFaIcon('faHandHoldingMedical'),
  'guest-parking': defineFaIcon('faSquareParking'),
  'guests-can-opt-out-of-daily-room-cleaning': defineFaIcon('faDoNotEnter'),
  'hair-beauty-salon': defineFaIcon('faChairOffice'),
  'restaurant-halal': defineFaIcon('faFlatbreadStuffed'),
  'hand-sanitizer-provided': defineFaIcon('faPumpMedical'),
  'happy-hour': defineFaIcon('faMartiniGlassCitrus'),
  heating: defineFaIcon('faHeat'),
  hiking: defineFaIcon('faPersonHiking'),
  'honeymoon-bridal-suite': defineFaIcon('faRingsWedding'),
  'horseback-riding': defineFaIcon('faHorse'),
  'hot-spring-bath': defineFaIcon('faHotTubPerson'),
  'hot-tub': defineFaIcon('faHotTubPerson'),
  'hygiene-certification': defineFaIcon('faFileCertificate'),
  'hypoallergenic-rooms': defineFaIcon('faFeather'),
  'indoor-play-area': defineFaIcon('faTeddyBear'),
  infirmary: defineFaIcon('faHouseMedical'),
  internet: defineFaIcon('faWifi'),
  invoices: defineFaIcon('faFileInvoiceDollar'),
  karaoke: defineFaIcon('faMicrophoneStand'),
  'key-card-or-motion-controlled-electricity':
    defineFaIcon('faCreditCardBlank'),
  'kids-club': defineFaIcon('faTeddyBear'),
  'kids-meals': defineFaIcon('faTv'),
  'restaurant-kosher': defineFaIcon('faPotFood'),
  'laundry-service': defineFaIcon('faWashingMachine'),
  library: defineFaIcon('faBookOpenCover'),
  'linens-towels-laundry-washed-per-local-authority-guidelines':
    defineFaIcon('faBlanket'),
  'live-music-performance': defineFaIcon('faMicrophoneStand'),
  'live-sports-events-broadcast': defineFaIcon('faTvMusic'),
  'local-safety-protocols-followed': defineFaIcon('faShieldVirus'),
  'locker-rooms': defineFaIcon('faLock'),
  lockers: defineFaIcon('faLock'),
  lounge: defineFaIcon('faLoveseat'),
  'low-bathroom-sink': defineFaIcon('faSink'),
  'meeting-rooms': defineFaIcon('faHandshake'),
  'miniature-golf': defineFaIcon('faGolfBallTee'),
  'minimarket-convenience-store': defineFaIcon('faBasketShopping'),
  'mobile-app-for-room-service': defineFaIcon('faMobileScreenButton'),
  'movie-nights': defineFaIcon('faPopcorn'),
  newspapers: defineFaIcon('faNewspaper'),
  'nightclub-dj': defineFaIcon('faCompactDisc'),
  'no-children-allowed': defineFaIcon('faBanSmoking'),
  'open-air-bath': defineFaIcon('faHotTubPerson'),
  'fireplace-outdoor': defineFaIcon('faCampfire'),
  'outdoor-furniture': defineFaIcon('faBenchTree'),
  'outdoor-play-equipment': defineFaIcon('faBaseballBatBall'),
  'personal-trainer': defineFaIcon('faDumbbell'),
  'photocopying-services': defineFaIcon('faPrint'),
  'physical-distancing-in-dining-areas': defineFaIcon('faPeopleArrows'),
  'physical-distancing-rules': defineFaIcon('faPeopleArrows'),
  'picnic-area': defineFaIcon('faTablePicnic'),
  playground: defineFaIcon('faBasketballHoop'),
  'pool-beach-towels': defineFaIcon('faBlanket'),
  'portable-wi-fi-device-rental': defineFaIcon('faRouter'),
  'postal-service': defineFaIcon('faEnvelope'),
  'prepared-lunches': defineFaIcon('faBowlHot'),
  printer: defineFaIcon('faPrint'),
  'beach-area-private': defineFaIcon('faUmbrellaBeach'),
  'private-check-in-check-out': defineFaIcon('faAddressCard'),
  'property-cleaned-by-professional-cleaning-companies':
    defineFaIcon('faHandSparkles'),
  'property-has-wheelchair-access': defineFaIcon('faWheelchair'),
  'public-transit-tickets': defineFaIcon('faTicket'),
  'racquetball-squash': defineFaIcon('faRacquet'),
  'raised-toilet': defineFaIcon('faToilet'),
  'refillable-water-stations': defineFaIcon('faGlassWaterDroplet'),
  restaurant: defineFaIcon('faUtensils'),
  'room-service': defineFaIcon('faBellConcierge'),
  'safety-deposit-box': defineFaIcon('faVault'),
  'safe-deposit-boxes-at-front-desk': defineFaIcon('faVault'),
  'sanitized-tableware': defineFaIcon('faHandSparkles'),
  sauna: defineFaIcon('faHeat'),
  'screens-between-staff-guests-where-needed': defineFaIcon('faPeopleArrows'),
  'security-alarm': defineFaIcon('faSirenOn'),
  'self-service-laundry': defineFaIcon('faWashingMachine'),
  'shared-kitchen': defineFaIcon('faOven'),
  'shared-lounge-tv-area': defineFaIcon('faTv'),
  shoeshine: defineFaIcon('faSparkles'),
  'shops-on-site': defineFaIcon('faShop'),
  shrine: defineFaIcon('faHandsPraying'),
  'shuttle-service': defineFaIcon('faVanShuttle'),
  'single-use-plastics-removed': defineFaIcon('faLeafHeart'),
  'ski-equipment-rental': defineFaIcon('faPersonSkiing'),
  skiing: defineFaIcon('faPersonSkiing'),
  'ski-school': defineFaIcon('faPersonSkiing'),
  'smoke-alarms': defineFaIcon('faSensorFire'),
  'smoke-free-property': defineFaIcon('faBanSmoking'),
  'snack-bar': defineFaIcon('faBurgerFries'),
  snorkeling: defineFaIcon('faMaskSnorkel'),
  solarium: defineFaIcon('faSun'),
  'soundproof-rooms': defineFaIcon('faVolumeSlash'),
  spa: defineFaIcon('faSpa'),
  'special-diet-meals-on-request': defineFaIcon('faSalad'),
  'stand-up-comedy': defineFaIcon('faMicrophoneStand'),
  'sterilizing-equipment': defineFaIcon('faSprayCan'),
  strollers: defineFaIcon('faBabyCarriage'),
  'suit-trouser-press': defineFaIcon('faClothesHanger'),
  'sun-deck': defineFaIcon('faSunCloud'),
  'surfing-lessons': defineFaIcon('faWaterLadder'),
  'table-tennis-ping-pong': defineFaIcon('faTableTennisPaddleBall'),
  'taxi-service': defineFaIcon('faTaxi'),
  'temperature-check-for-guests-and-staff': defineFaIcon('faTemperatureHigh'),
  'temporary-art-galleries': defineFaIcon('faPalette'),
  'tennis-court': defineFaIcon('faTennisBall'),
  terrace: defineFaIcon('faBenchTree'),
  'themed-dinners': defineFaIcon('faPanFood'),
  'thermometers-for-guests': defineFaIcon('faThermometer'),
  'ticketing-service': defineFaIcon('faTicket'),
  'toilet-with-grab-rails': defineFaIcon('faUniversalAccess'),
  'tour-assistance': defineFaIcon('faPersonSign'),
  'towels-changed-upon-request': defineFaIcon('faBlanket'),
  '24-hour-check-in': defineFaIcon('faBellConcierge'),
  '24-hour-front-desk': defineFaIcon('faBellConcierge'),
  'room-service-24-hours': defineFaIcon('faBellConcierge'),
  '24-hour-security': defineFaIcon('faShieldCheck'),
  'valet-service': defineFaIcon('faCarGarage'),
  'vending-machine-drinks': defineFaIcon('faCupStrawSwoosh'),
  'vending-machine-snacks': defineFaIcon('faBurrito'),
  'vending-machines-contents-unspecified': defineFaIcon('faBurrito'),
  'vip-room-facilities': defineFaIcon('faStar'),
  'visual-aids-braille': defineFaIcon('faBraille'),
  'visual-aids-tactile-signs': defineFaIcon('faHand'),
  'walking-tours': defineFaIcon('faMap'),
  'water-park': defineFaIcon('faRollerCoaster'),
  'water-sports-equipment-rental': defineFaIcon('faMaskSnorkel'),
  'water-sports-non-motorized': defineFaIcon('faPersonSwimming'),
  'welcome-drink': defineFaIcon('faChampagneGlass'),
  'wine-champagne': defineFaIcon('faChampagneGlass'),
};

export const customIcons = {};

function defineFaIcon(
  icon: Exclude<
    | keyof typeof FaProLight
    | keyof typeof FaProRegular
    | keyof typeof FaProSolid,
    'fal' | 'far' | 'fas' | 'prefix'
  >
) {
  return {
    light: FaProLight[icon],
    regular: FaProRegular[icon],
    solid: FaProSolid[icon],
  };
}
